import React from 'react';
import ProgressMatrixTable from './ProgressMatrixTable';

/**
 * Renders the Data Owner Progress Matrix.
 * Shows data owner details in rows, time periods/Annual/FY Total in columns,
 * with completions displayed as "completed / total" fractions.
 */
const DataOwnerMatrix = ({ matrixData, loading }) => {
  return (
    <ProgressMatrixTable
      matrixData={matrixData}
      loading={loading}
      title="Data Owner Progress Matrix"
      subtitle="Detailed completion per month/period (answered / assigned)"
      icon="📅"
    />
  );
};

export default DataOwnerMatrix;
